import { render, staticRenderFns } from "./LoginImportFromId.vue?vue&type=template&id=4b0d4b94&scoped=true&"
import script from "./LoginImportFromId.vue?vue&type=script&lang=js&"
export * from "./LoginImportFromId.vue?vue&type=script&lang=js&"
import style0 from "./LoginImportFromId.vue?vue&type=style&index=0&id=4b0d4b94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0d4b94",
  null
  
)

export default component.exports